import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import ClientName from './title/client_name/ClientName';
import ClientDetails from './client_details/ClientDetails';

// The header of a Loom lead. It follows the client view's header, minus the announcement.
const ClientHeader = (props) => {
  const {
    clientData,
    clientCareplan,
    setRefresh,
  } = props;

  return (
    <Stack gap={1}>
      <ClientName
        clientData={clientData}
        setRefresh={setRefresh}
      />
      <ClientDetails
        clientData={clientData}
        clientCareplan={clientCareplan}
        setRefresh={setRefresh}
      />
    </Stack>
  );
};
ClientHeader.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientCareplan: PropTypes.object,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientHeader);
